import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { TagPicker } from '../../exams/common/QuestionTools'
import '../../exams/common/_questionTools.scss'

// Bookmark modal for revision materials, short notes, notes and bookmark
// screens, in the exam question tools' look.
//
// The parent owns the bookmark fields (btags / bnewtag, validated into
// formValid3) and saves them in bookhandleFormSubmit, reporting back through
// currentStep 5 (saved) or submitError3. So this form hands its choice to the
// parent's own change handlers and then submits. One step per tick: the
// parent's validation runs in setState callbacks and two fields set in the same
// tick would overwrite each other's valid flag.

const tick = () => new Promise((resolve) => setTimeout(resolve, 0));
const errorOf = (e) => (Array.isArray(e) ? e.join(", ") : e ? String(e) : "");

class BookmarkForm extends Component {
    state = {
        tagMode: this.props.tags.length > 0 ? "existing" : "new",
        selected: [],
        newTag: "",
        error: "",
        saving: false,
    };

    componentWillUnmount() {
        this.unmounted = true;
    }

    componentDidUpdate(prevProps) {
        if (!this.state.saving) return;
        if (prevProps.serverError !== this.props.serverError && errorOf(this.props.serverError)) {
            this.setState({ saving: false, error: errorOf(this.props.serverError) });
        }
    }

    submit = async () => {
        const { tags, setTags, setNewTag, onSave } = this.props;
        const { tagMode, selected, newTag } = this.state;
        if (tagMode === "existing" && selected.length === 0) return this.setState({ error: "Select at least one tag." });
        if (tagMode === "new" && !newTag.trim()) return this.setState({ error: "Type a name for the new tag." });

        // A "new" name matching one of their tags is saved as that tag.
        const name = newTag.trim();
        const match = tagMode === "new" ? tags.find((t) => String(t.tag).trim().toLowerCase() === name.toLowerCase()) : null;
        const ids = tagMode === "existing" ? selected : match ? [String(match.id)] : [];
        const picked = tags.filter((t) => ids.includes(String(t.id))).map((t) => ({ value: String(t.id), label: t.tag }));

        this.setState({ saving: true, error: "" });
        if (ids.length > 0) {
            setNewTag("");
            await tick();
            setTags(picked);
        } else {
            setTags([]);
            await tick();
            setNewTag(name);
        }
        await tick();
        if (!this.unmounted) onSave();
    };

    render() {
        const { tags, saved, onClose } = this.props;
        const { tagMode, selected, newTag, error, saving } = this.state;
        return (
            <div className="qt-form">
                <div className="qt-head">
                    <span className="qt-head-icon qt-head-icon--bookmark"><i className="fas fa-bookmark" /></span>
                    <h6 className="qt-title">Bookmark</h6>
                    <button type="button" className="qt-close" aria-label="Close" onClick={onClose}><i className="fas fa-times" /></button>
                </div>

                {saved ? (
                    <div className="qt-done"><i className="fas fa-check-circle" /> Bookmarked.</div>
                ) : (
                    <>
                        <div className="qt-body">
                            <TagPicker
                                label="Your bookmark tags"
                                tags={tags}
                                selected={selected}
                                mode={tagMode}
                                onMode={(m) => this.setState({ tagMode: m, error: "" })}
                                newTag={newTag}
                                onSetSelected={(ids) => this.setState({ selected: ids, error: "" })}
                                onNewTag={(value) => this.setState({ newTag: value, error: "" })}
                            />
                            {error ? <div className="qt-error" role="alert"><i className="fas fa-exclamation-circle" /> {error}</div> : null}
                        </div>
                        <div className="qt-foot">
                            <button type="button" className="qt-btn qt-btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
                            <button type="button" className="qt-btn qt-btn--primary" onClick={this.submit} disabled={saving}>
                                {saving ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

class SingleBookModal extends Component {
    render() {
        const { show, onHide, stateData, studentGlobals = {}, custonid, removecontypId } = this.props;
        const tags = (studentGlobals.tags || []).filter((t) => t && t.type === "bookmark");
        return (
            <Modal show={show} onHide={() => onHide()} centered className="qt-modal" aria-label="Bookmark">
                {show ? (
                    <BookmarkForm
                        key={String(custonid)}
                        tags={tags}
                        saved={stateData.currentStep == 5}
                        serverError={stateData.submitError3}
                        setTags={(picked) => this.props.handleMutipleInputChange(picked, "btags")}
                        setNewTag={(value) => this.props.handleInputChange({ target: { name: "bnewtag", value } })}
                        onSave={() => this.props.bookhandleFormSubmit(removecontypId, custonid)}
                        onClose={() => onHide()}
                    />
                ) : null}
            </Modal>
        );
    }
}

export default SingleBookModal;
